// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_TITLE_STROLLER_REVIEWS_stroller = "%(stroller)s - U\u017eivatelsk\u00e9 hodnocen\u00ed a recenze - Ko\u010d\u00e1rkopedie";
export const STROLLER_ADD_REVIEW = "P\u0159idej hodnocen\u00ed";
export const STROLLER_SEO_GENERAL_DESC = "Velk\u00e1 datab\u00e1ze ko\u010d\u00e1rk\u016f Modr\u00e9ho kon\u00edka";
